<template>
  <div class="youtubes" :class="[`columns-${columns}`]">
    <div class="video" v-for="entry in entries" :key="`youtube-video-${entry.id}`">
      <iframe
        :src="`https://www.youtube-nocookie.com/embed/${entry.id}`"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen />
    </div>
  </div>
</template>

<script>
  let uid = 0;

  export default {
    name: 'Youtube',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      content: {
        type: Object,
        default: () => ({}),
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      uid += 1;
      return {
        iuid: `youtube-${uid}`,
        instance: null,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      entries() {
        const entries = this.content?.entries || [];
        return entries.filter(e => e.id !== null && e.id !== '');
      },
      columns() {
        return this.content?.columns || 2;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.youtubes {
  position: relative;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-bottom: 100px;
  gap: 32px;

  @include screen-mobile {
    gap: 16px;
  }

  & > .video {
    & > iframe {
      inset: 0;
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  &.columns-1 {
    & > .video {
      position: relative;
      width: 100%;
      aspect-ratio: 16/9;
      padding-bottom: 56.25%;
    }
  }

  &.columns-2 {
    & > .video {
      position: relative;
      width: calc(50% - 16px);
      aspect-ratio: 16/9;
      padding-bottom: calc(56.25% / 2);

      @include screen-mobile {
        width: 100%;
        aspect-ratio: 16/9;
        padding-bottom: 56.25%;
      }
    }
  }

  &.columns-3 {
    & > .video {
      position: relative;
      width: calc(33% - 16px);
      aspect-ratio: 16/9;
      padding-bottom: calc(56.25% / 3);

      @include screen-mobile {
        width: 100%;
        aspect-ratio: 16/9;
        padding-bottom: 56.25%;
      }
    }
  }
}
</style>
